export default "__VITE_ASSET__2067c31a__"